import PaymentLink from './PaymentLink';
export default PaymentLink;
